/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaRegolaPunteggioFasciaDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioFasciaCreationForm } from '../model/models';
import { TipoPraticaRegolaPunteggioFasciaDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioFasciaPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaRegolaPunteggioFasciaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    tipoPraticaRegolaPunteggioFasciaCreationForm: TipoPraticaRegolaPunteggioFasciaCreationForm;
}

export interface DeleteTipoPraticaRegolaPunteggioFasciaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    idFascia: string;
}

export interface GetTipoPraticaRegolaPunteggioFasciaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    idFascia: string;
}

export interface ListTipoPraticaRegolaPunteggioFasceRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    pageable: Pageable;
}

export interface UpdateTipoPraticaRegolaPunteggioFasciaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    idFascia: string;
    tipoPraticaRegolaPunteggioFasciaPatchForm: TipoPraticaRegolaPunteggioFasciaPatchForm;
}


export interface TipoPraticaRegolaPunteggioFasciaControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova fascia della regola A_FASCE
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce
* @param requestParameters
     */
    createTipoPraticaRegolaPunteggioFascia(requestParameters: CreateTipoPraticaRegolaPunteggioFasciaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioFasciaDTO>;

    /**
     * Elimina una fascia della regola
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce/{idFascia}
* @param requestParameters
     */
    deleteTipoPraticaRegolaPunteggioFascia(requestParameters: DeleteTipoPraticaRegolaPunteggioFasciaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di una fascia della regola
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce/{idFascia}
* @param requestParameters
     */
    getTipoPraticaRegolaPunteggioFascia(requestParameters: GetTipoPraticaRegolaPunteggioFasciaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioFasciaDTO>;

    /**
     * Lista paginata delle fasce della regola, ordinate per ordine ASC
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce
* @param requestParameters
     */
    listTipoPraticaRegolaPunteggioFasce(requestParameters: ListTipoPraticaRegolaPunteggioFasceRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaRegolaPunteggioFasciaDTO>;

    /**
     * Replace di una fascia della regola (richiede version)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/fasce/{idFascia}
* @param requestParameters
     */
    updateTipoPraticaRegolaPunteggioFascia(requestParameters: UpdateTipoPraticaRegolaPunteggioFasciaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioFasciaDTO>;

}
